import React from "react"
import { Helmet } from "react-helmet"

const Head = ({ title, meta, children }) => (
  <>
    <Helmet defaultTitle="Open Ground Tickets" title={title} meta={meta}>
      {children}
    </Helmet>
  </>
)

export default Head
